export default "__VITE_ASSET__D$EpzIJc__"